<template>
	<div class="cassie-vertical-md mt-1">
		<FilterBar
			:search-query.sync="searchQuery"
			search-query-label="Submission"
			hide-brand-filter
		/>
		<SectionCard>
			<template #title>
				Submission Failures Log
			</template>
			<template #body>
				<DataTable
					:headers="tableHeaders"
					:items="logs"
					:items-per-page="50"
					sort-by="submissionId"
					sort-desc
					hide-default-footer
					height="70vh"
					@click:row="openSubmissionModal"
				>
					<template #item.action="{ item }">
						<v-menu
							v-if="submissionFailures.hasPii"
							offset-y
							left
						>
							<template #activator="{ on, attrs }">
								<v-btn
									icon
									v-bind="attrs"
									v-on="on"
									@click.stop
								>
									<v-icon>
										mdi-dots-horizontal
									</v-icon>
								</v-btn>
							</template>
							<v-list dense>
								<v-list-item
									@click="openSubmissionModal(item)"
								>
									<v-list-item-title>
										View Full Submission
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
				</DataTable>
			</template>
		</SectionCard>
		<Modal
			v-if="submissionFailures.hasPii && showSubmissionStringModal"
			width="800px"
		>
			<template #modal-title>
				SubmissionID: {{ openSubmissionId }}
				<v-spacer />
				<IconButton @click="closeSubmissionModal()">
					mdi-close
				</IconButton>
			</template>
			<template #modal-content>
				<div class="cassie-vertical-md">
					<vue-json-pretty
						v-if="validJson && rawSubmissionString"
						:data="rawSubmissionString"
					/>
					<div v-else>
						{{ rawSubmissionString }}
					</div>
				</div>
			</template>
			<template #modal-footer>
				<SecondaryActionButton @click="closeSubmissionModal">
					Close
				</SecondaryActionButton>
			</template>
		</Modal>
	</div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import FilterBar from '../../../../../../shared/components/filter-bar.vue'
import SectionCard from '../../../../../../shared/components/section-card.vue'
import DataTable from '../../../../../../shared/components/data-table.vue'
import Modal from '../../../../../../shared/components/modal.vue'
import SecondaryActionButton from '../../../../../../shared/components/secondary-action-button.vue'
import IconButton from '../../../../../../shared/components/icon-button.vue'

export default {
	components: { DataTable, SectionCard, Modal, SecondaryActionButton, VueJsonPretty, IconButton, FilterBar },
	props: {
		submissionFailures: {
			type: Object
		},
		submission: Object
	},
	data () {
		return {
			searchQuery: null,
			validJson: false,
			rawSubmissionString: null,
			showSubmissionStringModal: false,
			openSubmissionId: null,
			tableHeaders: [
				{ value: 'submissionId', text: 'ID', width: '10%' },
				{ value: 'submissionDateTime', text: 'Submission Date', width: '20%' },
				{ value: 'type', text: 'Type', width: '15%' },
				{ value: 'failureType', text: 'Failure Type', width: '35%' }
			]
		}
	},
	computed: {
		logs () {
			return this.submissionFailures?.submissionFailures?.filter(({ submission }) => {
				let check = true
				if (this.searchQuery) check = submission?.toLowerCase().includes(this.searchQuery.toLowerCase())
				return check
			})
		}
	},
	async created () {
		if (this.submissionFailures.hasPii) {
			this.tableHeaders.splice(1, 0, { value: 'limitedSubmission', text: 'Submission', width: '25%' })
			this.tableHeaders.push({ value: 'action', text: 'Action', width: '80px', align: 'center', sortable: false })
		}
	},
	methods: {
		openSubmissionModal (row) {
			if (!this.submissionFailures.hasPii) {
				this.showSubmissionStringModal = false
			}
			this.openSubmissionId = row.submissionId
			this.loading = true
			try {
				this.validJson = true
				this.rawSubmissionString = JSON.parse(row.submission) ?? 'Submission String is not available'
			} catch (error) {
				this.validJson = false
				this.rawSubmissionString = row.submission ?? 'Submission String is not available'
			}
			this.showSubmissionStringModal = true
		},
		closeSubmissionModal () {
			this.rawSubmissionString = null
			this.validJson = false
			this.showSubmissionStringModal = false
			this.openSubmissionId = null
		}
	}
}
</script>
